"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Icon;
exports.propTypes = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _kebabCase = _interopRequireDefault(require("lodash/kebabCase"));
const _excluded = ["children", "className", "label", "width", "height", "viewBox", "size", "style"];
const classString = require('../../helpers').classString;

// NOTE: if you change these default values, all the icons will need to be redesigned a bit.
// since they are all assumed to have a viewBox of 16x16, changing them will affect scaling and clipping.
const DEFAULT_WIDTH = 16;
const DEFAULT_HEIGHT = 16;
const ICON_SIZES = {
  default: {
    width: DEFAULT_WIDTH,
    height: DEFAULT_HEIGHT
  },
  small: {
    width: 12,
    height: 12
  },
  medium: {
    width: 20,
    height: 20
  },
  large: {
    width: 24,
    height: 24
  }
};
function Icon(_ref) {
  let {
      children,
      className,
      label,
      width,
      height,
      viewBox,
      size,
      style
    } = _ref,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const svgWidth = width || (typeof ICON_SIZES[size]?.width === 'number' ? ICON_SIZES[size]?.width : DEFAULT_WIDTH);
  const svgHeight = height || (typeof ICON_SIZES[size]?.height === 'number' ? ICON_SIZES[size]?.height : DEFAULT_HEIGHT);
  const iconExternalName = (0, _kebabCase.default)(label);
  const whitelabelSelectorClass = `anvil-icon-${iconExternalName}`;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: svgWidth,
    height: svgHeight,
    viewBox: viewBox || `0 0 ${DEFAULT_WIDTH} ${DEFAULT_HEIGHT}` // default viewBox is 16x16. if you want a diff viewBox, you're on you're own
    ,
    role: "graphics-symbol",
    "aria-label": label,
    xmlns: "http://www.w3.org/2000/svg",
    className: classString([className, `icon-${iconExternalName}`, whitelabelSelectorClass]),
    style: style
  }, others), children);
}
Icon.defaultProps = {
  size: 'default'
};
const propTypes = exports.propTypes = {
  className: _propTypes.default.string,
  label: _propTypes.default.string,
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  viewBox: _propTypes.default.string,
  size: _propTypes.default.oneOf(Object.keys(ICON_SIZES))
};
Icon.propTypes = Object.assign({
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node])
}, propTypes);